const CURRENCIES = [
  { value: "USD", label: "USD" },
  { value: "CAD", label: "CAD" },
  { value: "EUR", label: "EUR" },
];

const CURRENCIES_WITH_FLAGS = [
  { value: "USD", label: "🇺🇸 USD" },
  { value: "CAD", label: "🇨🇦 CAD" },
  { value: "EUR", label: "🇪🇺 EUR" },
];

const CURRENCY_NAMES = {
  usd: "USD",
  cad: "CAD",
  ur: "EUR",
};

export { CURRENCY_NAMES, CURRENCIES_WITH_FLAGS };

export default CURRENCIES;
